import { render, staticRenderFns } from "./module-info.vue?vue&type=template&id=62ee6ebe&scoped=true"
import script from "./module-info.vue?vue&type=script&lang=js"
export * from "./module-info.vue?vue&type=script&lang=js"
import style0 from "./module-info.vue?vue&type=style&index=0&id=62ee6ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ee6ebe",
  null
  
)

export default component.exports